/* eslint-disable prettier/prettier */ /* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {  useState,
  useContext,
  useEffect,
} from 'react';
import Grid from '@material-ui/core/Grid';
import BalanceFilter from './BalanceFilter';
import { BalanceTable } from './BalanceTable';
import api from '../../../../service/axios/api';
import FlashContext from '../../../../components/contexts/FlashContext';

export function Balance({ setLoading, setMsg }) {
  const [dataCategory, setdataCategory] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const { notifyError } = useContext(FlashContext);
  const [chipData, setChipData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    searchData();
  }, []);

  const searchData = updatedChips => {
    setMsg(`Buscando saldo dos clientes...`);
    setLoading(true);

    const filtersToSend =
      updatedChips && Array.isArray(updatedChips) ? updatedChips : chipData;

    api.order
      .getOrdersBalance(filtersToSend, page + 1, itens)
      .then(res => {
        setTotal(res.data.total);
        setdataCategory(res.data.docs);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        notifyError(error.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  const templateDownload = () => {
    setMsg(
      `Gerando planilha, isso pode levar alguns ${
        total > 100000 ? 'minutos' : 'segundos'
      }...`,
    );
    setLoading(true);
    api.order
      .getOrdersBalanceXls(chipData)
      .then(res => {
        const url = res.data.retorno.link;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'saldo_clientes.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        if (err?.response?.data) {
          if (err.response.data.Problems) {
            err.response.data.Problems.forEach(e => {
              notifyError(e.Message);
            });
          } else {
            notifyError(err.response.data.Message);
          }
        } else if (err.message) {
          if (err.message === 'Network Error') {
            notifyError(
              'Erro de conexão, verifique sua conexão com a internet e tente novamente',
            );
          } else {
            notifyError(err.message);
          }
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        style={{ display: 'flex', justifyContent: 'start' }}
      >
        <h3>Saldo dos clientes</h3>
      </Grid>
      <BalanceFilter
        setChipData={setChipData}
        chipData={chipData}
        find={searchData}
        setPage={setPage}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      <BalanceTable
        docs={dataCategory}
        page={page}
        setPage={setPage}
        itens={itens}
        setItens={setItens}
        total={total}
        getXls={templateDownload}
      />
    </>
  );
}
